module.exports = __webpack_public_path__ + "static/media/girl-8.c4ee2bb4.svg";